// Svensk organisationsnummer validator
export const isValidOrgNumber = (orgNr: string): boolean => {
  // Ta bort mellanslag och bindestreck
  orgNr = orgNr.replace(/[- ]/g, "");

  // Måste vara 10 eller 12 siffror
  if (!/^\d{10}$|^\d{12}$/.test(orgNr)) {
    return false;
  }

  if (orgNr.length === 12) {
    // För 12-siffriga organisationsnummer, ta de sista 10 siffrorna
    orgNr = orgNr.substring(2);
  }

  // Kontrollsifferberäkning för 10-siffriga nummer
  // Modulus-10 metoden (Luhn-algoritmen)
  let sum = 0;

  for (let i = 0; i < 10; i++) {
    let digit = parseInt(orgNr.charAt(i));

    // Multiplicera varannan siffra med 2
    if (i % 2 === 0) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }

    sum += digit;
  }

  return sum % 10 === 0;
};

export const formatOrgNumber = (orgNr: string): string => {
  // Ta bort allt utom siffror
  const digitsOnly = orgNr.replace(/\D/g, "");

  if (digitsOnly.length === 12) {
    return `${digitsOnly.substring(0, 8)}-${digitsOnly.substring(8)}`;
  } else if (digitsOnly.length === 10) {
    return `${digitsOnly.substring(0, 6)}-${digitsOnly.substring(6)}`;
  }

  return digitsOnly;
};
